import { AuthService, UICommandInterface } from '@nts/std';
import { ExternalReturnAwareInterface } from '../external-return-aware.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChangeDetectorRef } from '@angular/core';

export const AUTH_CONSTANTS = {
  MESSAGES: {
    LOGIN_IN_PROGRESS: 'Accesso in corso...',
    AUTO_LOGIN_IN_PROGRESS: 'Accesso automatico in corso...',
    LOGIN_PROFILE_NOT_FOUND: 'Login non avvenuto, profilo non trovato',
    LOGIN_INVALID_TOKEN: 'Login non avvenuto, token non valido'
  },
  STORAGE_KEYS: {
    REMEMBER_ME: 'rememberMe',
    DEVICE_ID: 'DEVICE_ID'
  },
  QUERY_PARAMS: {
    REDIRECT_URL: 'redirect-url',
    CLIENT_ID: 'client-id',
    STATE: 'state',
    HIDE_REMEMBER_ME: 'hide-remember-me',
    SCOPES: 'scopes',
    VATNUMBER: 'vatnumber',
    EMAIL: 'email',
    DEVICE_ID: 'device-id',
    FORCE_SKIP_AUTO_LOGIN: 'force-skip-auto-login',

    /**
     * // Attenzione non confondere con tenantId utilizzato su std AuthService
     * qui è utilizzato per passare l'informazione al backend nel dto EmailPasswordCredentialDto per fare il login
     * mentre su AuthService è utilizzato per settare il tenantId nel browser storage
     */
    LOGIN_TENANT_ID: 'tenant-id'
  }
} as const;

export class BaseAuthComponent implements ExternalReturnAwareInterface {

  isEmailFromQueryString = false
  commandMessageAction = null
  authConstants = AUTH_CONSTANTS;

  constructor(
    public fb: FormBuilder,
    public cd: ChangeDetectorRef
  ) {
    this.fb = fb;
    this.cd = cd;
  }

  async handlePendingChanges(): Promise<boolean> {
    return false;
  }

  async checkEmailFromQueryString<TForm extends FormGroup>(
    form: TForm,
    emailFieldName: keyof TForm = 'email' as keyof TForm
  ) {
    const email = this.getEmailFromQueryString()

    // utilizza il validatore di angular per la email per validare la mail
    const isValidEmail = this.validateEmailWithFormBuilder(email);

    if (email && email.length > 0 && isValidEmail) {
      form.patchValue({ [emailFieldName]: email });

      // Imposta il flag per lo styling
      this.isEmailFromQueryString = true;
    }
  }

  /**
     * Ritorna l'url di destinazione con i query params della rotta corrente (esclusi quelli di auth)
     * @param destinationUri Url di destinazione
     * @returns
     */
  protected getUrlWithCurrentQueryParams(destinationUri: string): string {
    const currentUrl = new URL(window.location.href);
    const currentUrlQueryParams = new URLSearchParams(currentUrl.search);

    const destinationUrl = new URL(destinationUri);
    // Per ogni query params della rotta corrente
    currentUrlQueryParams.forEach((value, key) => {
      // se non è un parametro di auth (es. redirect-url, ecc...) lo aggiungo al redirect url
      if (
        [
          AUTH_CONSTANTS.QUERY_PARAMS.REDIRECT_URL,
          AuthService.ACCESS_TOKEN_QUERY_KEY,
          AuthService.REFRESH_TOKEN_QUERY_KEY,
          AuthService.CLEAR_AUTH_QUERY_KEY
        ].indexOf(key) === -1
      ) {
        destinationUrl.searchParams.set(key, value);
      }
    });

    return destinationUrl.toString();
  }

  addExternalReturnCommand(commandMessageAction: any) {
    this.commandMessageAction = commandMessageAction;
    // commandMessageAction(this.orchestrator.getCurrentIdentity());
    //     setTimeout(() => {
    //         window.close();
    //     }, 100);
  }

  executeCommandMessageAction(data) {
    this.commandMessageAction(JSON.stringify(data))
    setTimeout(() => {
      window.close();
    }, 100);
  }

  getEmailFromQueryString(): string | null {
    const url = new URL(window.location.href);
    const urlQueryParams = new URLSearchParams(url.search);
    return urlQueryParams.get(AUTH_CONSTANTS.QUERY_PARAMS.EMAIL);
  }

  validateEmailWithFormBuilder(email: string, fb: FormBuilder = this.fb): boolean {
    const emailControl = fb.control(email, [Validators.email]);
    return emailControl.valid;
  }

  setUICommand(en: string, ui: UICommandInterface): UICommandInterface {

    ui.displayName = en; //MessageResourceManager.Current.getMessage('CMD_' + en);
    ui.name = en;
    ui.tooltip = ui.displayName;

    return ui;
  }
}
